import GiftVouchersTotals from './gift_voucher_totals';
import OutstandingGiftVouchers from './outstanding_gift_vouchers';

export default {
    GiftVouchersTotals,
    OutstandingGiftVouchers
};
